import PropTypes from 'prop-types';

export default function FormFieldError({ messages }) {
	return <div className="form-field-errors">{messages.length > 0 && <span className="form-field-error">{messages[0]}</span>}</div>;
}

FormFieldError.propTypes = {
	messages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
